import { useState, useEffect } from 'react';
import { Cookie, X, Check } from 'lucide-react';

const COOKIE_KEY = 'flitship_cookie_consent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [prefs, setPrefs] = useState({
    analytics: false,
    marketing: false
  });

  useEffect(() => {
    const stored = localStorage.getItem(COOKIE_KEY);
    if (!stored) {
      setTimeout(() => setVisible(true), 1500);
    }
  }, []);

  const save = (acceptAll) => {
    const consent = {
      necessary: true,
      analytics: acceptAll || prefs.analytics,
      marketing: acceptAll || prefs.marketing,
      date: new Date().toISOString()
    };
    localStorage.setItem(COOKIE_KEY, JSON.stringify(consent));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[99999] 
                    md:bottom-4 md:left-4 md:right-auto 
                    md:max-w-[420px]">
      <div className="bg-white border border-[#e8e3dc] 
                      rounded-t-2xl md:rounded-2xl shadow-xl p-5">
        
        {/* Header */}
        <div className="flex items-start justify-between gap-3 mb-3">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-full bg-[#eff4ff] 
                            flex items-center justify-center flex-shrink-0">
              <Cookie className="w-4 h-4 text-[#3c6df0]" />
            </div>
            <p className="font-['Space_Grotesk'] text-[14px] 
                          font-bold text-[#1f1f1f]">
              Cookies Flitship
            </p>
          </div>
          <button onClick={() => save(false)}
            className="text-[#a3a3a3] hover:text-[#1f1f1f] 
                       transition-colors flex-shrink-0">
            <X className="w-4 h-4" />
          </button>
        </div>

        {/* Message */}
        <p className="text-[13px] text-[#737373] font-['Inter'] 
                      leading-[1.6] mb-4">
          Nous utilisons des cookies pour améliorer votre expérience 
          et analyser l'utilisation de la Plateforme.{' '}
          <a href="/legal/cookies" 
             className="text-[#3c6df0] hover:underline">
            En savoir plus
          </a>
        </p>

        {/* Details toggle */}
        {showDetails && (
          <div className="space-y-2 mb-4 p-3 bg-[#faf6f2] 
                          rounded-xl">
            <label className="flex items-center justify-between gap-3 
                               cursor-pointer">
              <div>
                <p className="text-[12px] font-semibold text-[#1f1f1f]">
                  Nécessaires
                </p>
                <p className="text-[11px] text-[#737373]">
                  Authentification, sécurité
                </p>
              </div>
              <div className="w-8 h-5 bg-[#4bb543] rounded-full 
                              flex items-center justify-end px-1">
                <div className="w-3 h-3 bg-white rounded-full" />
              </div>
            </label>
            <label className="flex items-center justify-between gap-3 
                               cursor-pointer">
              <div>
                <p className="text-[12px] font-semibold text-[#1f1f1f]">
                  Analytics
                </p>
                <p className="text-[11px] text-[#737373]">
                  PostHog, Sentry
                </p>
              </div>
              <button
                onClick={() => setPrefs(p => ({
                  ...p, analytics: !p.analytics
                }))}
                className={`w-8 h-5 rounded-full transition-colors 
                            flex items-center px-1 ${
                  prefs.analytics 
                    ? 'bg-[#3c6df0] justify-end' 
                    : 'bg-[#e8e3dc] justify-start'
                }`}>
                <div className="w-3 h-3 bg-white rounded-full" />
              </button>
            </label>
            <label className="flex items-center justify-between gap-3 
                               cursor-pointer">
              <div>
                <p className="text-[12px] font-semibold text-[#1f1f1f]">
                  Marketing
                </p>
                <p className="text-[11px] text-[#737373]">
                  Brevo, OneSignal
                </p>
              </div>
              <button
                onClick={() => setPrefs(p => ({
                  ...p, marketing: !p.marketing
                }))}
                className={`w-8 h-5 rounded-full transition-colors 
                            flex items-center px-1 ${
                  prefs.marketing 
                    ? 'bg-[#3c6df0] justify-end' 
                    : 'bg-[#e8e3dc] justify-start'
                }`}>
                <div className="w-3 h-3 bg-white rounded-full" />
              </button>
            </label>
          </div>
        )}

        {/* Actions */}
        <div className="flex gap-2">
          <button
            onClick={() => setShowDetails(!showDetails)}
            className="flex-1 py-2 text-[12px] font-medium 
                       border border-[#e8e3dc] text-[#737373] 
                       rounded-xl hover:border-[#3c6df0] 
                       hover:text-[#3c6df0] transition-colors">
            {showDetails ? 'Masquer' : 'Personnaliser'}
          </button>
          {showDetails && (
            <button
              onClick={() => save(false)}
              className="flex-1 py-2 text-[12px] font-medium 
                         border border-[#3c6df0] text-[#3c6df0] 
                         rounded-xl hover:bg-[#eff4ff] 
                         transition-colors">
              Enregistrer
            </button>
          )}
          <button
            onClick={() => save(true)}
            className="flex-1 py-2 text-[12px] font-semibold 
                       text-white rounded-xl transition-opacity 
                       hover:opacity-90 flex items-center 
                       justify-center gap-1"
            style={{ backgroundColor: '#3c6df0' }}>
            <Check className="w-3.5 h-3.5" />
            Accepter
          </button>
        </div>
      </div>
    </div>
  );
}
